export function objListToMap(objList, keyField, valueField) {
    var map = [];
    objList && objList.forEach((o) => map[o[keyField]] = o[valueField]);
    return map;
}